// Direct-upload helpers put an absolute URL in data-direct-upload-url via
// rails_direct_uploads_url. In development that uses default_url_options
// (www.lvh.me:2345) which often is not the host the browser is on (e.g.
// port 3000). POSTing there never reaches this app, so Dropzone never
// injects a signed blob id and the photo form 500s.
export function resolveDirectUploadUrl(raw, location = window.location) {
  if (!raw) {
    return '/rails/active_storage/direct_uploads'
  }

  try {
    const parsed = new URL(raw, location.origin)
    if (parsed.host !== location.host) {
      return `${parsed.pathname}${parsed.search}`
    }
    return parsed.href
  } catch {
    return raw
  }
}
